const credentialingOperationsUsers = [
    "tech-support@humantold.com",
    "credentials@humantold.com",
    "systems@humantold.com",
    "developer@douglasgrppractice.com",
];

const appSettings = {
    CREDENTIAL_EXPIRATION_STATUS_USERS: credentialingOperationsUsers,
    CREDENTIALING_VALIDATION_BYPASS_USERS: credentialingOperationsUsers,
    OFFICE_MANAGEMENT_BETA_ADMIN_USERS: [
        "developer@douglasgrppractice.com",
        "intake@humantold.com",
        "m.maas@humantold.com",
    ],
    OFFICE_MANAGEMENT_BETA_CLINICIAN_USERS: [
        "m.cruz@humantold.com",
        "t.edwards@humantold.com",
        "t.williams@humantold.com",
        "developer@douglasgrppractice.com",
    ],
    SUPERVISORS_WITH_PH_DEPARTMENT: [
        "s.spielberger@humantold.com",
        "p.giambona@humantold.com",
    ],
};

export function canViewCredentialExpirationStatus(
    email?: string | null,
    isIntakeUser = false
): boolean {
    if (email?.toLowerCase() === "c.lim@humantold.com") {
        return false;
    }
    return (
        isIntakeUser ||
        appSettings.CREDENTIAL_EXPIRATION_STATUS_USERS.includes(
            email?.toLowerCase() ?? ""
        )
    );
}

export function canManageClinicianCredentials(
    email?: string | null,
    isIntakeUser = false
): boolean {
    if (email?.toLowerCase() === "c.lim@humantold.com") {
        return false;
    }
    return (
        isIntakeUser ||
        appSettings.CREDENTIALING_VALIDATION_BYPASS_USERS.includes(
            email?.toLowerCase() ?? ""
        )
    );
}

export function hasOfficeAdminBetaAccess(email: string): boolean {
    return true; // appSettings.OFFICE_MANAGEMENT_BETA_ADMIN_USERS.includes(email);
}

export function hasOfficeClinicianBetaAccess(email: string): boolean {
    return true; // appSettings.OFFICE_MANAGEMENT_BETA_CLINICIAN_USERS.includes(email);
}

export default appSettings;
